import { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import FormLabel from './FormLabel';
import FormErrorIndicator from './FormErrorIndicator';

const defaultProps = {
  label: null,
  labelClassName: null,
  error: null,
  touched: false,
  errorIndicatorOnTop: false,
  optional: false,
};

const propTypes = {
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  errorIndicatorOnTop: PropTypes.bool,
  optional: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default function FormControl({
  label,
  labelClassName,
  error,
  touched,
  errorIndicatorOnTop,
  optional,
  children,
}) {
  const [isFocus, setFocus] = useState(false);

  const hasLabel = label !== null;
  const hasError = error !== null && touched === true;

  return (
    <label className={clsx('w-full flex flex-col space-y-2 font-semibold', labelClassName)} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}>
      {hasLabel && (<FormLabel label={label} isFocus={isFocus} optional={optional} />)}
      <div className="relative z-10">
        <div className="relative z-0">
          {children}
        </div>
        {hasError && (
          <div
            className={clsx(
              'absolute top-0 bottom-0 right-0 z-10 flex px-3',
              errorIndicatorOnTop === false && 'items-center',
              errorIndicatorOnTop === true && 'items-start pt-3',
            )}
          >
            <FormErrorIndicator errorMessage={error} />
          </div>
        )}
      </div>
    </label>
  );
}

FormControl.defaultProps = defaultProps;
FormControl.propTypes = propTypes;
